export const Pdf = class {
  constructor() {
    this.idCount = 0;
    this.data = [];
  }
  addObject(dict, stream, specId) {
    if (typeof stream === 'string') {
      dict['Length'] = stream.length;
    }
    let arr = [];
    let id;
    if (specId === undefined) {
      id = ++this.idCount;
    } else {
      id = specId;
    }
    arr.push(`${id} 0 obj`);
    arr.push('<<');
    for (let key in dict) {
      arr.push(`/${key} ${dict[key]}`);
    }
    arr.push('>>');
    if (typeof stream === 'string') {
      arr.push('stream');
      arr.push(stream);
      arr.push('endstream');
    }
    arr.push('endobj');
    this.data[id - 1] = arr.join('\n');
  }
  preserveId() {
    return ++this.idCount;
  }
  output(rootId) {
    let header = '%PDF-1.4\n%ยงยง';
    let xrefArr = ['0000000000 65535 f '];
    let pos = header.length + 3;
    this.data.forEach((obj) => {
      let s = pos.toString();
      s = '0'.repeat(10 - s.length) + s;
      xrefArr.push(`${s} 00000 n `);
      pos += obj.length + 1;
    });
    return `${header}
${this.data.join('\n')}
xref
0 ${this.data.length + 1}
${xrefArr.join('\n')}
trailer
<<
/Size ${this.data.length + 1}
/Root ${rootId} 0 R
>>
startxref
${pos}
%%EOF
`;
  }
  toDataUrl=function(rootId) {
    return 'data:application/pdf;base64,' + Pdf.btoa_utf8(this.output(rootId));
  }
  static btoa_utf8(str) {
    const u8enc = new TextEncoder();
    return btoa(Array.from(u8enc.encode(str), x=>String.fromCodePoint(x)).join(''));
  }
}